export class Espace {
    idespace: string;
    designation: string;
    mailresponsables: String;
    resarecquis: boolean;
    heuredebut: string;
    heurefin: string;

}



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/model/espace.model.ts